import {  useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Plus, FileDown, Grip, Tally2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import StaffTableSkeleton from "@/components/skeleton/Staff-skeletion";
import Paginate from "@/components/lib/paginat";
import { Link } from "react-router-dom";
import OnlyTableSkeleton from "@/components/skeleton/only-table-skeleton";
import useAuth from "@/hooks/useAuth";
import { CustomerTypeTable } from "@/components/backoffice/settings/customer-type";
import { TabsContent } from "@radix-ui/react-tabs";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { FaXmark } from "react-icons/fa6";
import toast from "react-hot-toast";
import { addCustomerTypeApi, deleteCustomerTypeApi, getAllCustomerTypeApi, updateCustomerTypeApi } from "@/api/settings/discount";
import { getAllCustomerApi } from "@/api/customer/customer";
import { set, status } from "nprogress";
import hasPermission from "@/hooks/hasPermission";

const customerTypeSchema = z.object({
  name: z.string().min(1, "Customer type is required!"),
  status: z.boolean().optional().default(false)
});



function AllCustomerType() {
  const { user } = useAuth();
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [addCustomerType, setAddCustomerType] = useState(false);
  const [editCustomerType, setEditCustomerType] = useState({id: null, name: null, status: null});
  const [deleteCustomerType, setDeleteCustomerType] = useState(false);
  const [deleteCustomerTypeId, setDeleteCustomerTypeId] = useState(null);

    const {
      register,
      handleSubmit,
      reset,
      formState: { errors }
    } = useForm({ resolver: zodResolver(customerTypeSchema) });

  if (loading) {
    return <StaffTableSkeleton />;
  }



  const onSubmit = (data) => {

    addCustomerTypeApi({...data, restaurant_id: user?.restaurant_id, status: data?.status == true ?"active" :"inactive"}).then((data)=>{

      if(data.status == "success"){
        toast.success("Customer Type Added Successfully")
        setCustomerTypeData(customerTypeData.concat(data?.data?.customer_type))
        reset();
        setAddCustomerType(false)
      }else{
        toast.error(data.message || "Something went wrong")
      }
    })
  };

    const updateCustomerType = (data) => {

    updateCustomerTypeApi(editCustomerType.id, {...data, restaurant_id: user?.restaurant_id, status: data?.status == true ?"active" :"inactive"}).then((data)=>{

      if(data.status == "success"){
        toast.success("Customer Type update Successfully")
        const newData = customerTypeData.map(type=>{
          if(data?.data?.customer_type?.id == type.id){
            
            return {...type, ...data?.data?.customer_type}
          }else{
            return type
          }
        })

        setCustomerTypeData(newData)
        reset();
        setEditCustomerType({id: null, name: null, status: null})
      }else{
        toast.error(data.message || "Something went wrong")
      }
    })
  };



  function deleteType(id){
    setDeleteCustomerTypeId(id);
  }


  useEffect(() => {
    getAllCustomerTypeApi( user?.restaurant_id, perPage).then((data) => {
      if (data.status == "success") {
        setCustomerTypeData(data?.data?.customer_types);
        setPagination(data?.data?.pagination);
      }
    });
  }, [currentPage, perPage]);




  return (
    <>
      {
        addCustomerType &&
        <div className="absolute w-full h-full bg-color1/60 flex items-center justify-center z-20">
          <div className=" mt-[200px] w-[600px] h-[400px] relative">
            <div className="absolute right-4 top-4 cursor-pointer text-color5 hover:text-color8 z-30" onClick={() => { setAddCustomerType(false); reset({ name: "", status: false }); }}>
              <FaXmark size={20} />
            </div>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="w-full max-w-4xl bg-color2 p-6 rounded-xl shadow-lg space-y-6"
            >
                <h2 className="text-2xl font-semibold text-center mb-4 pb-2 border-b border-color3 text-color5">Add New Customer Type</h2>
                <div>
                    <label className="block mb-1  font-semibold text-color5">Customer Type</label>
                    <input
                        className="w-full p-2 rounded bg-color3 border-none outline-none text-color5"
                        placeholder="Enter Customer Type"
                        {...register("name")}
                    />
                    {errors.name && <p className="text-red-400 text-sm">{errors.name.message}</p>}
                </div>
                <label className="flex items-center gap-2 text-white font-semibold cursor-pointer">
                  <input type="checkbox" className=" w-4 h-4 accent-color6 " {...register("status")} /> Is Active?
                </label>
                <div className=" flex gap-4">
                  <button type="button" onClick={() => { setAddCustomerType(false); reset({ name: "", status: false }); }} className=" w-full py-2 text-center bg-color8 rounded-md text-white" >Cancel</button>
                  <button type="submit" className=" w-full py-2 text-center bg-color6 rounded-md text-white" >Submit</button>
                </div>
            </ form>
          </div>
        </div>
      }
      {
        editCustomerType.id !== null &&
        <div className="absolute w-full h-full bg-color1/60 flex items-center justify-center z-20">
          <div className=" mt-[200px] w-[600px] h-[400px] relative">
            <div className="absolute right-4 top-4 cursor-pointer text-color5 hover:text-color8 z-30" onClick={() => { setEditCustomerType({id: null, name: null, status: null}); reset({ name: "", status: false }); }}>
              <FaXmark size={20} />
            </div>
            <form
              onSubmit={handleSubmit(updateCustomerType)}
              className="w-full max-w-4xl bg-color2 p-6 rounded-xl shadow-lg space-y-6"
            >
                <h2 className="text-2xl font-semibold text-center mb-4 pb-2 border-b border-color3 text-color5">Update Customer Type</h2>
                <div>
                    <label className="block mb-1  font-semibold text-color5">Customer Type</label>
                    <input
                        className="w-full p-2 rounded bg-color3 border-none outline-none text-color5"
                        placeholder="Enter Customer Type"
                        {...register("name")}
                    />
                    {errors.name && <p className="text-red-400 text-sm">{errors.name.message}</p>}
                </div>
                <label className="flex items-center gap-2 text-white font-semibold cursor-pointer">
                  <input type="checkbox" className=" w-4 h-4 accent-color6 " {...register("status")} /> Is Active?
                </label>
                <div className=" flex gap-4">
                  <button type="button" onClick={() => { setEditCustomerType({id: null, name: null, status: null}); reset({ name: "", status: false }); }} className=" w-full py-2 text-center bg-color8 rounded-md text-white" >Cancel</button>
                  <button type="submit" className=" w-full py-2 text-center bg-color6 rounded-md text-white" >Submit</button>
                </div>
            </ form>
          </div>
        </div>
      }
      {
        deleteCustomerTypeId !== null &&
        <div className="absolute w-full h-full bg-color1/60 flex items-center justify-center z-20">
          <div className="w-[450px] bg-color2 p-6 rounded-xl shadow-lg border border-color3 text-center space-y-6">
            <h2 className="text-xl font-semibold text-color5">Delete Customer Type</h2>
            <p className="text-color5/80 text-sm">Are you sure you want to delete this customer type? This action cannot be undone.</p>
            <div className="flex gap-4">
              <button 
                type="button"
                onClick={() => setDeleteCustomerTypeId(null)} 
                className="w-full py-2 text-center bg-color3 rounded-md text-color5 hover:bg-color3/80 transition-colors"
              >
                Cancel
              </button>
              <button 
                type="button"
                onClick={() => {
                  deleteCustomerTypeApi(deleteCustomerTypeId).then((data) => {
                    if (data.status === "success") {
                      toast.success("Customer Type Deleted Successfully");
                      setCustomerTypeData(customerTypeData.filter((item) => item.id !== deleteCustomerTypeId));
                    } else {
                      toast.error(data.message || "Something went wrong");
                    }
                    setDeleteCustomerTypeId(null);
                  });
                }} 
                className="w-full py-2 text-center bg-color8 rounded-md text-white hover:bg-color8/80 transition-colors"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      }
      <TabsContent value="customer-type">
        <div className="container flex flex-col gap-4 mt-5">
          <div className="flex justify-between items-start md:items-center md:flex-row flex-col gap-5  w-full">
            <div className="flex gap-5 text-white"></div>
            {hasPermission("back_office.settings.customer_type_create") && (
              <Button onClick={() => { setAddCustomerType(true); reset({ name: "", status: false }); }} className="bg-cyellow hover:bg-cyellow text-black">
                <Plus className="mr-2 h-4 w-4" />
                Add New Customer Type
              </Button>
            )}
          </div>

          <Card className="bg-cblack3 border-0">
            <CardContent className="flex justify-between flex-col gap-5 items-center mt-4">
              <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
                <div className="flex justify-between items-center gap-3">
                </div>
                <div className="flex flex-col  gap-1.5 justify-end items-end">
                  <div className="flex gap-3 justify-center items-center">
                    <div className="flex gap-1 justify-center items-center">
                      <h3 className="text-white">Show</h3>
                      <Select
                        onValueChange={(value) => setPerPage(Number(value))}
                        value={perPage.toString()}
                      >
                        <SelectTrigger className="w-[60px]">
                          <SelectValue placeholder="10" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectGroup>
                            <SelectItem value="10">10</SelectItem>
                            <SelectItem value="20">20</SelectItem>
                            <SelectItem value="40">40</SelectItem>
                          </SelectGroup>
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full">
                {searchLoading ? (
                  <OnlyTableSkeleton header={false} />
                ) : (
                  <CustomerTypeTable
                    setTableData={setCustomerTypeData}
                    tableData={customerTypeData}
                    deleteType={deleteType}
                    setEditCustomerType={setEditCustomerType}
                    reset={reset}
                  />
                )}

                <Paginate
                  className="mt-2"
                  pagination={pagination}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
            </CardContent>
          </Card>
        </div>
      </TabsContent>
    </>
  );
}

export default AllCustomerType;
